// extracted by mini-css-extract-plugin
module.exports = {"errorCode":"ErrorPage_errorCode__lPAWA","parentLink":"ErrorPage_parentLink__X_dqd","link":"ErrorPage_link__Fvz4x"};